import styles from './styles.module.css';
import React, { CSSProperties } from 'react';
import { ImageSvg } from '../utils/customIcon';

interface Props {
	containerClass?: String;
	imgClass?: String;
	containerCss?: CSSProperties;
	imgCss?: CSSProperties;
}

export const BeefCow = (props: Props) => {
	const svg = require('./beef-cattle.svg');
	return <ImageSvg {...props} svg={svg} />;
};
